import { Box } from "@mui/material";
import { PillSkeleton } from "@src/appV2/redesign/system/ui-components";

interface FilterSectionSkeletonProps {
  itemsCount?: number;
  ariaLabel?: string;
}

export function FilterSectionSkeleton(props: FilterSectionSkeletonProps) {
  const { itemsCount = 4, ariaLabel } = props;

  return (
    <Box
      role="progressbar"
      aria-label={ariaLabel}
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: 3,
      }}
    >
      {Array.from({ length: itemsCount }).map((_, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <PillSkeleton key={index} />
      ))}
    </Box>
  );
}
